// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"8d7e3814","647":"b5a5e937"}[chunkId] + ".chunk.js";
};